export default "__VITE_ASSET__R$qZymBz__"